import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { MeetingLinkReadonlyActionsComponent } from 'src/app/components/meeting-link-readonly-actions/meeting-link-readonly-actions.component';
import { DocentTimetableRow } from 'src/app/models/docent-timetable-entry.model';
import { MeetingLinkDocentDTO } from 'src/app/models/meeting-link-docent-dto.model';
import { user } from 'src/app/models/user.model';
import { MeetingLinkDocentActionsComponent } from 'src/app/teams-zoom-config/components/meeting-link-docent-actions/meeting-link-docent-actions.component';
import {
  isMissingTeamsLink,
  MISSING_TEAMS_LINK_HINT,
} from '../../docent-timetable-helpers';

/**
 * Meeting-Spalte eines Stundenplaneintrags in allen Zuständen — fehlendes Teams-Meeting,
 * bearbeitbar durch die Verwaltung, nur lesbar, gar kein Meeting hinterlegt. Tabelle und Karten
 * teilen sich diese Komponente, damit die Fallunterscheidung nur an einer Stelle steht.
 */
@Component({
  selector: 'app-docent-timetable-meeting-actions',
  standalone: true,
  imports: [
    TagModule,
    TooltipModule,
    MeetingLinkReadonlyActionsComponent,
    // Zyklus-Kette DialogManagerService.
    forwardRef(() => MeetingLinkDocentActionsComponent),
  ],
  templateUrl: './docent-timetable-meeting-actions.component.html',
  styleUrl: './docent-timetable-meeting-actions.component.scss',
})
export class DocentTimetableMeetingActionsComponent {
  @Input({ required: true }) entry!: DocentTimetableRow;

  /** Nur die Verwaltung darf Meetings je Zeile bearbeiten. */
  @Input() canEdit = false;

  /** Für den Meeting-Bearbeiten-Dialog nötig. */
  @Input() lecturerUsers: user[] = [];

  @Input() label = '';

  @Output() meetingChanged = new EventEmitter<void>();

  readonly missingTeamsLinkHint = MISSING_TEAMS_LINK_HINT;
  readonly isMissingTeamsLink = isMissingTeamsLink;

  canEditTeamsMeeting(entry: DocentTimetableRow): boolean {
    return this.canEdit && entry.meetingType === 'Teams' && !!entry.meetingId;
  }

  // DocentTimetableRow tippt die Felder als string | null, MeetingLinkDocentDTO als string | undefined.
  toMeetingLinkData(entry: DocentTimetableRow): MeetingLinkDocentDTO {
    return {
      docentName: entry.docentName,
      meetingId: entry.meetingId ?? undefined,
      meetingLink: entry.meetingLink ?? undefined,
      meetingName: entry.meetingName ?? undefined,
    };
  }
}
